/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday December 4th 2023
 * Author: KasunKarunasekara
 * -----
 * Last Modified: Monday December 4th 2023 5:31:05 pm
 * Modified By: KasunKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  AppBar,
  Hidden,
  Toolbar,
  IconButton,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
//
import Searchbar from '../util-components/Searchbar';
import AccountPopover from '../util-components/AccountPopover';
import LanguagePopover from '../util-components/LanguagePopover';
import NotificationsPopover from '../util-components/NotificationsPopover';
import ClientLogo from '../../components/shared/ClientLogo';
import Logo from 'src/components/shared/Logo';
import NavItems from './NavItems';
import Menubar from './Menubar';
import DashboardDateFilter from 'src/components/shared/DashboardDateFilter';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getFiscalYear } from 'src/redux/slices/custom-calendar';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 0;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 70;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: theme.palette.primary.main,
  [theme.breakpoints.up('lg')]: {
    width: '100%'
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 4)
  }
}));

// ----------------------------------------------------------------------

NavbarHorizontal.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function NavbarHorizontal({ onOpenSidebar }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const isExtraLarge = useMediaQuery(theme.breakpoints.up('lg'));
  useEffect(() => {
    dispatch(getFiscalYear());
  }, []);

  return (
    <RootStyle>
      <ToolbarStyle>
        <Hidden lgUp>
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: 'text.primary' }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </Hidden>
        {/* <Searchbar /> */}
        <Hidden lgDown>
          <NavItems />
        </Hidden>
        <Box sx={{ flexGrow: 1 }} />
        {/* <NotificationsPopover /> */}
        <Box sx={{ pr: 2, pt: 1 }}>
          <DashboardDateFilter />
        </Box>
        <Box sx={{ pr: 2, pt: 1 }}>
          <Menubar />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > *:not(:first-of-type)': {
              ml: { xs: 1.5, sm: 2, lg: 1 }
            },
            borderRadius: '8px',
            // border: `1px solid ${theme.palette.common.white}`,
            overflow: 'hidden',
            p: 0.3,
            pt: 1
          }}
        >
          <ClientLogo height={25} />
          <AccountPopover />
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
